import React from "react";

import "./styles.scss"
import ChatInsightsMain from "../../esg-chat/insights";

const CompanyInsights = () => {
    return (
        <ChatInsightsMain model="Company" />
    )
}

export default CompanyInsights